const PKG_NS = "http://schemas.microsoft.com/office/2006/xmlPackage";
const REL_NS = "http://schemas.openxmlformats.org/package/2006/relationships";

const HEADER_FOOTER_RELATIONSHIP_TYPES = new Set([
    "http://schemas.openxmlformats.org/officeDocument/2006/relationships/header",
    "http://schemas.openxmlformats.org/officeDocument/2006/relationships/footer",
]);

const MAX_REPORTED_VIOLATIONS = 20;

function resolvePackagePath(sourcePartName: string, target: string): string {
    if (target.startsWith("/")) {
        return target;
    }
    const sourceDirectory = sourcePartName.slice(0, sourcePartName.lastIndexOf("/"));
    const segments: string[] = [];
    for (const segment of `${sourceDirectory}/${target}`.split("/")) {
        if (segment === "" || segment === ".") continue;
        if (segment === "..") {
            segments.pop();
            continue;
        }
        segments.push(segment);
    }
    return `/${segments.join("/")}`;
}

function relsSourcePartName(relsPartName: string): string {
    const marker = relsPartName.lastIndexOf("_rels/");
    const directory = relsPartName.slice(0, marker);
    const filename = relsPartName.slice(marker + "_rels/".length);
    return directory + filename.replace(/\.rels$/, "");
}

export function findUnresolvedPackageReferences(packageOoxml: string): string[] {
    if (!packageOoxml.includes(PKG_NS)) {
        return [];
    }
    const doc = new DOMParser().parseFromString(packageOoxml, "text/xml");
    if (doc.querySelector("parsererror")) {
        return [];
    }

    const parts = new Map<string, Element>();
    for (const part of Array.from(doc.getElementsByTagNameNS(PKG_NS, "part"))) {
        const name = part.getAttributeNS(PKG_NS, "name");
        if (name) parts.set(name, part);
    }

    const violations: string[] = [];

    for (const [partName, part] of parts) {
        if (!partName.endsWith(".rels")) continue;
        const sourcePartName = relsSourcePartName(partName);
        for (const relationship of Array.from(part.getElementsByTagNameNS(REL_NS, "Relationship"))) {
            const type = relationship.getAttribute("Type");
            if (type === null || !HEADER_FOOTER_RELATIONSHIP_TYPES.has(type)) continue;
            if (relationship.getAttribute("TargetMode") === "External") continue;
            const targetValue = relationship.getAttribute("Target");
            if (targetValue === null) continue;
            const target = resolvePackagePath(sourcePartName, targetValue);
            if (parts.has(target)) continue;
            violations.push(
                `relationship ${relationship.getAttribute("Id")} in ${partName} targets ${target} but the package contains no part with that name`,
            );
        }
    }

    return violations;
}

export function formatUnresolvedPackageReferences(violations: string[]): string {
    const shown = violations.slice(0, MAX_REPORTED_VIOLATIONS);
    const listed = shown.join("; ");
    if (violations.length > shown.length) {
        return `${listed} (showing ${shown.length} of ${violations.length} violations)`;
    }
    return listed;
}
